import Blue from "~/core";

new Blue({
	name: 'Footer',
	selector: ".footer",
	setup(footer) {
		const navItems = [...footer.querySelectorAll('.footer__sub-links > .sub-link__column')];
		const subAccordion = footer.querySelector('.footer__sub-accordion');
		/* Script for the footer goes here */
		// navItems.forEach(i => {
			// this.$retach(i, {
			// 	destination: subAccordion,
			// 	mediaQuery: this.$screen.lg_dn,
			// 	movedClass: 'link-groups',
			// });
		// });

		const relations = [];

		const toggleMenu = item => {
			if (this.$screen.lg.matches) return;
			item.toggle();
		};

		navItems.forEach(container => {
			const trigger = container.querySelector('.sub-link__title');
			const content = container.querySelector('.sub-link__content');
			const config = {
				container,
				trigger,
				content,
				relations,
				externalEvents: true,
				props: ['height', 'opacity'],
			};
			const toggle = new this.$toggle(config);
			relations.push(toggle);
			this.$addEvents(trigger, 'click.prevent', () => toggleMenu(toggle));
		});
	}
});
